import React from "react";
import "./index.css";

const Navbar = () => (
  <ul className="navbar-container">
    <li>Bags</li>
    <li>Travel</li>
    <li>Accesories</li>
    <li>Gifting</li>
    <li>Jewelery</li>
  </ul>
);
export default Navbar;
